import { Injectable, Type } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  FnTransferableArg,
  UiArguments,
} from "shared/provider-webworker";
import { ReplicaBlotterLookupService } from "../../impl/ReplicaBlotterLookupService";
import { IScratchPadDataPromiseLookupService } from "../IScratchPadDataPromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class ScratchPadDataReplicaLookupService
  extends ReplicaBlotterLookupService<
    string,
    CubiqTS.LinkedOrderRequestImpl | CubiqTS.FixingOrderRequestImpl
  >
  implements IScratchPadDataPromiseLookupService
{
  protected readonly ORDER_DATA: CubiqTS.ConcreteEncodable;

  constructor(protected factory: ClientMessageBrokerFactory) {
    super(
      factory,
      [CubiqTS.LinkedOrderRequestImpl, CubiqTS.FixingOrderRequestImpl] as any,
      "LinkedOrderRequestImpl",
      CubiqTS.SavedOrderEventImpl,
      true,
    );

    this.ORDER_DATA = CubiqTS.ENCODABLE(CubiqTS.OrderDataImpl);
  }

  addOrderEntryReference(ref: string): Promise<boolean> {
    let request = new UiArguments("addOrderEntryReference");
    let arg1 = new FnArg(ref, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  removeOrderEntryReference(ref: string): Promise<boolean> {
    let request = new UiArguments("removeOrderEntryReference");
    let arg1 = new FnArg(ref, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  hasOrderEntryReference(ref: string): Promise<boolean> {
    let request = new UiArguments("hasOrderEntryReference");
    let arg1 = new FnArg(ref, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  getOrderData(reference: string): Promise<CubiqTS.OrderDataImpl> {
    let request = new UiArguments("getOrderData");
    let arg1 = new FnArg(reference, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.ORDER_DATA);
  }

  cloneItems(
    orderIDs: string[],
  ): Promise<Array<CubiqTS.LinkedOrderRequestImpl | CubiqTS.FixingOrderRequestImpl>> {
    let request = new UiArguments("cloneItems");
    let arg1 = new FnArg(orderIDs, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }
}
